export const energy_use_cat = {
  state: {
    energy_use_cats: []
  },
  mutations: {
    updateEnergyUseCats: function(state, newList) {
      state.energy_use_cats = newList;
    }
  },
  getters: {
    getAllEnergyUseCats(state) {
      return state.energy_use_cats;
    },
    getEnergyUseSubCatsByUseCat(_, getters) {
      return function(useCatUUID) {
        const energyUseCat = getters.getEnergyUseCat(useCatUUID);
        return energyUseCat.energy_use_sub_cats;
      }
    },
    getEnergyUseCat(state) {
      return function(uuid) {
        return state.energy_use_cats.find(function(c) {
          return (c.uuid == uuid)
        })
      }
    },
    getEnergyUseSubCatByUUID(_, getters) {
      return function(uuid) {
        const use_cats = getters.getAllEnergyUseCats;
        return use_cats.reduce(function(res, use_cat) {
          return res || getters.getEnergyUseSubCatwithCat(use_cat, uuid);
        }, null);
      }
    },
    getEnergyUseCatWithSubCat(state) {
      return function(uuidOfSubCat) {
        return state.energy_use_cats.find(function(c) {
          const subCat = c.energy_use_sub_cats.find(function(subCat) {
            return (subCat.uuid == uuidOfSubCat)
          });
          // for clarity
          if (subCat) {
            return true
          } else {
            return false
          }
        });
      }
    },
    getEnergyUseSubCatwithCat() {
      return function(useCat, uuidOfSubCat) {
        return useCat.energy_use_sub_cats.find(function(subCat) {
          return (subCat.uuid == uuidOfSubCat);
        })
      }
    }
  }
}